import { Translator } from 'Translator';
import Popover from 'components/Popover';
import RadioButton from 'components/RadioButton';
import { AVAILABILITY_FILTER_OPTIONS } from 'data/subOptions/availabilitySubOptions';
import MonthCarousel from 'modules/common/Navbar/popovers/AgendaPopover/MonthCarousel';
import React from 'react';

const CSS = require('./AgendaPopover.less');

interface AgendaPopoverProps {
  onSelectDate: (date: Date) => void;
  onClickNow: () => void;
  onClickToday: () => void;
  onClickTomorrow: () => void;
  onApply: (
    source:
      | 'escape button'
      | 'outside click'
      | 'apply button'
      | 'availability button',
  ) => (e: any) => void;
  onClear: (e: any) => void;
  startDate: Date;
  endDate: Date;
  showAvailabilityOptions: { show: boolean; showNow: boolean };
  noBackdrop?: boolean;
}

const AgendaPopover = ({
  startDate,
  endDate,
  onSelectDate,
  onApply,
  onClear,
  showAvailabilityOptions,
  noBackdrop,
  onClickNow,
  onClickToday,
  onClickTomorrow,
}: AgendaPopoverProps) => {
  return (
    <div className={CSS.PeoplePopover}>
      <Popover
        show
        name="agendaPopover"
        underNavbar
        noBackdrop={noBackdrop}
        className={CSS.Popover}
        onClose={onApply('escape button')}
        onOutSideClick={onApply('outside click')}
      >
        <div className={CSS.PopoverContent}>
          {showAvailabilityOptions.show && (
            <div className={CSS.FiltersContainer}>
              <h2 className={CSS.FiltersTitle}>
                {Translator.translate(
                  'Common.DatePicker.whenDoYouWantToGo',
                  {},
                  true,
                  'When do you want to go?',
                )}
              </h2>
              <div className={CSS.Filters}>
                {showAvailabilityOptions.showNow && (
                  <div className={CSS.Filter} onClick={onClickNow}>
                    <RadioButton
                      value={AVAILABILITY_FILTER_OPTIONS.NOW}
                      className={CSS.FilterCheckbox}
                      name={'availability'}
                    />
                    <span className={CSS.FilterLabel}>
                      {Translator.translate(
                        'SearchPage.DateFilter.availabilityNow',
                        {},
                        true,
                        'Now',
                      )}
                    </span>
                  </div>
                )}
                <div className={CSS.Filter} onClick={onClickToday}>
                  <RadioButton
                    value={AVAILABILITY_FILTER_OPTIONS.TODAY}
                    name={'availability'}
                    className={CSS.FilterCheckbox}
                  />
                  <span className={CSS.FilterLabel}>
                    {Translator.translate(
                      'SearchPage.DateFilter.availabilityToday',
                      {},
                      true,
                      'Today',
                    )}
                  </span>
                </div>
                <div className={CSS.Filter} onClick={onClickTomorrow}>
                  <RadioButton
                    value={AVAILABILITY_FILTER_OPTIONS.TOMORROW}
                    name={'availability'}
                    className={CSS.FilterCheckbox}
                  />
                  <span className={CSS.FilterLabel}>
                    {Translator.translate(
                      'SearchPage.DateFilter.availabilityTomorrow',
                      {},
                      true,
                      'Tomorrow',
                    )}
                  </span>
                </div>
              </div>
              <div className={CSS.Separator}>
                {Translator.translate('Forms.Separator.or', {}, true, 'or')}
              </div>
            </div>
          )}
          <div className={CSS.Carousel}>
            <MonthCarousel
              onSelectDate={onSelectDate}
              startDate={startDate}
              endDate={endDate}
            />
          </div>
        </div>
        <div className={CSS.StickyContainer}>
          <div className={CSS.ButtonContainer}>
            <button className={CSS.ClearButton} onClick={onClear}>
              {Translator.translate('Common.Clear', {}, true, 'Clear')}
            </button>
            <button
              className={CSS.ApplyButton}
              onClick={onApply('apply button')}
            >
              {Translator.translate('Common.Apply', {}, true, 'Apply')}
            </button>
          </div>
        </div>
      </Popover>
    </div>
  );
};

export default AgendaPopover;
